namespace RioERP.Web.Enums {
    export enum FranchiseeDiscount {
        Percentage = 1,
        FixedAmount = 2
    }
    Serenity.Decorators.registerEnumType(FranchiseeDiscount, 'RioERP.Web.Enums.FranchiseeDiscount');
}
